import { Headline, HtmlContainer } from "@n2-common/ui";
import { N2ApplicationStatus } from "@n2-common/serverGeneratedTypings/n2ApplicationStatus";
import { CommonStatusPageProps } from "@n2-common/components/ApplicationStatusPage";
import { useTranslation } from "react-i18next";
import { useApplicationIdContext } from "@n2-common/components/ApplicationContext";
import { trackCoreBankEvent } from "@n2-common/lib/gtm";
import { useEffect, useState } from "react";
import { ApplicationStatusModel } from "@n2-common/serverGeneratedTypings/applicationStatusModel";
import { fetchApplicationStatusAndRedirectIfNotExpectedState, translationNamepaceFromProduct } from "../applicationStatusHelpers";
import { useNavigate } from "react-router-dom";

const  CompletedPage = ({ navigateToCorrectStepFunc }: CommonStatusPageProps): JSX.Element => {
    const navigate = useNavigate();

    const { country, productType, applicationId } = useApplicationIdContext();

    const translationNameSpace = translationNamepaceFromProduct(productType);
    
    const { t } = useTranslation(translationNameSpace);
  
    const [applicationStatus, setApplicationStatus] = useState<ApplicationStatusModel|null>(null);

    useEffect(() => {
        fetchApplicationStatusAndRedirectIfNotExpectedState(
            applicationId,
            '',
            (res) => res.Status === N2ApplicationStatus.Completed,
            setApplicationStatus,
            navigate,
            navigateToCorrectStepFunc
        );
    }, [applicationId, navigate, navigateToCorrectStepFunc]);
    useEffect(()  => {

        if (!applicationStatus) {
            return;
        }
        trackCoreBankEvent(productType, country, "application_complete", undefined, applicationId, applicationStatus.IsAgentApplication);

    }, [navigate, productType, country, applicationId, applicationStatus]);
   
    return <div>
        <Headline>{t<string>("ApplicationLandingPages.Completed.Headline")}</Headline>
        <Headline level={3}>{t<string>("ApplicationLandingPages.Completed.SubHeadline")}</Headline>
         <HtmlContainer innerHtml={t<string>('ApplicationLandingPages.Completed.Body', '')} />
    </div>
};

export default CompletedPage;